<template>
  <div class="success-box">
    <div class="success-box__content">
      <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0715 0C22.8473 0 25.4394 0.526975 27.8526 1.57616C30.2683 2.62772 32.3691 4.05127 34.1672 5.83964C35.9533 7.6304 37.3745 9.7383 38.4261 12.1466C39.4754 14.5645 40 17.1613 40 19.932C40 22.7028 39.4754 25.3043 38.4261 27.7413C37.3745 30.1806 35.9533 32.3052 34.1672 34.1246C32.3691 35.9416 30.2683 37.3747 27.8526 38.4262C25.4394 39.4754 22.8473 40 20.0715 40C17.2457 40 14.6202 39.4754 12.1808 38.4262C9.74365 37.3747 7.63086 35.9416 5.84714 34.1246C4.04912 32.3052 2.62549 30.1806 1.57625 27.7413C0.524621 25.3043 0 22.7028 0 19.932C0 17.1613 0.524621 14.5645 1.57625 12.1466C2.62549 9.7383 4.04912 7.6304 5.84714 5.83964C7.63086 4.05127 9.74365 2.62772 12.1808 1.57616C14.6202 0.526975 17.2457 0 20.0715 0Z" fill="#3FD34E"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M30.0199 15.5566C30.4539 15.165 30.6673 14.6823 30.6673 14.1158C30.6673 13.5493 30.4539 13.0419 30.0199 12.5985C29.6339 12.1995 29.1639 12 28.6124 12C28.0609 12 27.5693 12.1995 27.1329 12.5985L17.182 22.9631L12.866 18.5197C12.432 18.1232 11.938 17.931 11.3865 17.931C10.835 17.931 10.3674 18.1232 9.979 18.5197C9.54499 18.968 9.33398 19.4729 9.33398 20.0394C9.33398 20.6059 9.54499 21.0887 9.979 21.4803L15.7529 27.4039C15.892 27.6502 16.091 27.8153 16.362 27.8867C16.6209 27.9631 16.9015 28 17.182 28C17.429 28 17.6664 27.9631 17.911 27.8867C18.1459 27.8153 18.345 27.6502 18.484 27.4039L30.0199 15.5566Z" fill="white"/>
      </svg>
      <p><slot/></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'success-box'
}
</script>

<style lang="scss">
.success-box {
  flex-basis: 100%;
  margin-top: 8px;
  text-align: left;

  &.success-enter-active, &.success-leave-active {
    transition: margin-left 0.2s, opacity .1s;
  }

  &.success-enter, &.success-leave-to {
    margin-left: -10px;
    opacity: 0;
  }

  &__content {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    background: #D9F4A8;
    border-radius: 16px;
    padding: 20px;

    svg {
      margin-right: 12px;
    }

    p {
      margin: 0;
      font-weight: normal;
    }
  }
}
</style>
